export default __webpack_public_path__ + "static/media/Web-passcode-SO.a363a285.jpg";